export default __webpack_public_path__ + "static/media/success-img.722f0bcf.png";